// The setup steps, in the order they are done (from the owner's "TCA XERO SETUP FILE" Google Sheet).
// The sheet's Step 01 ("click to reset") is gone: reloading the page starts a fresh checklist.
// Each step's Xero API call is added in processStep() (App.js) as the owner supplies it.

export const PROVINCES = [
  'Eastern Cape', 'Free State', 'Gauteng', 'KwaZulu-Natal', 'Limpopo',
  'Mpumalanga', 'North West', 'Northern Cape', 'Western Cape',
];

export const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

// Field types: text, tel, email, date, select, yesno, tracking (a category name plus its options).
// `group` starts a sub-heading inside the step; `wide` spans both columns.
export const STEPS = [
  {
    id: 'entity',
    title: "SELECT THE CLIENT'S XERO ORGANISATION",
    fields: [
      {
        name: 'organisation', label: 'Xero Organisation', type: 'select', wide: true,
        options: [], emptyText: 'Organisations will load once Xero is connected',
      },
    ],
  },
  {
    id: 'tcaContact',
    title: "CREATE THE CLIENT AS A CONTACT IN TC AUDITORS' XERO",
    fields: [
      { group: 'Company Details', name: 'cipcReg', label: 'CIPC Registration Number', type: 'text', placeholder: 'YYYY/NNNNNN/NN' },
      { name: 'taxNumber', label: 'VAT / Income Tax Number', type: 'text' },
      { name: 'bankAccount', label: 'Bank Account Number', type: 'text' },
      { group: 'Cellphone Numbers', name: 'cell1', label: 'Cellphone 01', type: 'tel' },
      { name: 'cell2', label: 'Cellphone 02', type: 'tel' },
      { name: 'cell3', label: 'Cellphone 03', type: 'tel' },
      { name: 'cell4', label: 'Cellphone 04', type: 'tel' },
      { group: 'Contact Person 01', name: 'firstName1', label: 'First Name', type: 'text' },
      { name: 'surname1', label: 'Surname', type: 'text' },
      { name: 'email1', label: 'Email Address', type: 'email', wide: true },
      { group: 'Contact Person 02', name: 'firstName2', label: 'First Name', type: 'text' },
      { name: 'surname2', label: 'Surname', type: 'text' },
      { name: 'email2', label: 'Email Address', type: 'email', wide: true },
      { group: 'Address', name: 'address1', label: 'Address Line 01', type: 'text' },
      { name: 'address2', label: 'Address Line 02', type: 'text' },
      { name: 'address3', label: 'Address Line 03', type: 'text' },
      { name: 'address4', label: 'Address Line 04', type: 'text' },
      { name: 'city', label: 'City', type: 'text' },
      { name: 'province', label: 'Province', type: 'select', options: PROVINCES },
      { name: 'postalCode', label: 'Postal Code', type: 'text', placeholder: '0000' },
    ],
  },
  {
    id: 'retainerInvoice',
    title: 'CREATE THE TC AUDITORS RETAINER INVOICE',
    fields: [
      { name: 'retainerStart', label: 'Retainer Start Date', type: 'date' },
      { name: 'yearEnd', label: 'Financial Year-End Month', type: 'select', options: MONTHS },
      { name: 'package', label: 'TCA Retainer Package', type: 'select', options: ['Bronze', 'Silver', 'Gold'] },
      { name: 'subscription', label: 'Xero Subscription', type: 'select', options: ['Starter', 'Standard', 'Premium'] },
      { name: 'whatsapp', label: 'WhatsApp Add-On', type: 'yesno' },
    ],
  },
  {
    id: 'vat',
    title: 'SET UP THE VAT TAX RATES',
    fields: [
      { name: 'vatRegistered', label: 'VAT Registered?', type: 'yesno' },
    ],
  },
  {
    id: 'tracking',
    title: 'SET UP THE TRACKING CATEGORIES',
    fields: [
      { name: 'trackingA', label: 'Tracking Category A', type: 'tracking', placeholder: 'e.g. Department' },
      { name: 'trackingB', label: 'Tracking Category B', type: 'tracking', placeholder: 'e.g. Sales Person' },
    ],
  },
  {
    id: 'deleteCoa',
    title: 'DELETE THE CURRENT CHART OF ACCOUNTS',
    warning: "This deletes the organisation's existing chart of accounts in Xero.",
    fields: [],
  },
  { id: 'setupCoa', title: 'SET UP THE TC AUDITORS CHART OF ACCOUNTS', fields: [] },
  { id: 'fixedAssets', title: 'SET UP THE FIXED ASSETS', fields: [] },
  { id: 'clientContact', title: "CREATE TC AUDITORS AS A CONTACT IN THE CLIENT'S XERO", fields: [] },
  { id: 'bills', title: "SET UP TC AUDITORS' BILLS (SEND / POST)", fields: [] },
  { id: 'onboardingInvoices', title: 'CREATE THE ONBOARDING INVOICES', fields: [] },
  { id: 'shareCapital', title: 'POST THE SHARE CAPITAL JOURNAL', fields: [] },
  { id: 'whatsappGroups', title: 'CREATE THE WHATSAPP GROUPS', fields: [] },
];

export const stepNumber = (index) => String(index + 1).padStart(2, '0');
